import {defineMessages} from 'react-intl';

export default defineMessages({
  answer: {
    defaultMessage: 'Learner\'s answer:',
    id: 'ReactiveForms.Forms.AttemptGradingForm.StudentAnswer.Answer',
  },
});
